import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/logo/orchit-logo.png'


const _hoisted_1 = { class: "orchit-login-root orchit-page" }
const _hoisted_2 = { class: "orchit-login-wrapper" }
const _hoisted_3 = { class: "orchit-login-card orchit-animate-fade-up" }
const _hoisted_4 = {
  key: 0,
  class: "orchit-login-headline orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_5 = {
  key: 1,
  class: "orchit-login-headline orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_6 = {
  key: 0,
  class: "orchit-login-subtitle"
}
const _hoisted_7 = { class: "orchit-gradient-text" }
const _hoisted_8 = {
  key: 1,
  class: "orchit-login-subtitle"
}
const _hoisted_9 = {
  key: 2,
  class: "orchit-login-headline orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_10 = {
  key: 3,
  class: "orchit-login-headline orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_11 = {
  key: 4,
  class: "orchit-login-headline orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_12 = {
  key: 5,
  class: "orchit-alert-error orchit-animate-fade-up",
  role: "alert",
  "aria-live": "polite"
}
const _hoisted_13 = { class: "orchit-input-wrap" }
const _hoisted_14 = {
  key: 0,
  id: "email-error",
  class: "orchit-error",
  role: "alert"
}
const _hoisted_15 = { class: "orchit-input-wrap" }
const _hoisted_16 = ["type"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 0,
  id: "password-error",
  class: "orchit-error",
  role: "alert"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "orchit-spinner",
  "aria-hidden": "true"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  style: {"margin-right":"6px"},
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "orchit-method-toggle orchit-animate-fade-up orchit-animate-delay-5" }
const _hoisted_26 = {
  key: 7,
  class: "orchit-otp-container orchit-animate-fade-up orchit-animate-delay-2"
}
const _hoisted_27 = { class: "orchit-otp-grid" }
const _hoisted_28 = ["onUpdate:modelValue", "onInput", "onKeydown", "disabled"]
const _hoisted_29 = { class: "orchit-otp-resend" }
const _hoisted_30 = {
  key: 0,
  class: "orchit-timer"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "orchit-spinner",
  "aria-hidden": "true"
}
const _hoisted_33 = { class: "orchit-back-to-login-wrap" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "orchit-input-wrap" }
const _hoisted_36 = {
  key: 0,
  class: "orchit-error"
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "orchit-spinner"
}
const _hoisted_39 = { class: "orchit-input-wrap" }
const _hoisted_40 = ["type"]
const _hoisted_41 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_42 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_43 = {
  key: 0,
  class: "orchit-error"
}
const _hoisted_44 = { class: "orchit-input-wrap" }
const _hoisted_45 = ["type"]
const _hoisted_46 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_47 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_48 = {
  key: 0,
  class: "orchit-error"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "orchit-spinner"
}
const _hoisted_51 = {
  key: 10,
  class: "orchit-login-form orchit-animate-fade-up",
  style: {"text-align":"center"}
}
const _hoisted_52 = { class: "orchit-login-footer orchit-animate-fade-up orchit-animate-delay-5" }
const _hoisted_53 = {
  class: "orchit-login-panel orchit-animate-fade-up orchit-animate-delay-1",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "orchit-panel-inner" }
const _hoisted_55 = { class: "orchit-panel-tagline" }

import { ref, computed, watch, nextTick, onMounted, onUnmounted } from "vue";
import apiService from "@/services/apiService";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// ── State ─────────────────────────────────────────────────────────────────

export default /*@__PURE__*/_defineComponent({
  __name: 'loginPage',
  setup(__props) {

const email       = ref("");
const password    = ref("");
const errorMessage= ref("");
const isLoading   = ref(false);
const showPassword= ref(false);
const loginMethod = ref<'password' | 'otp'>('password');
const loginStep   = ref<'login' | 'otp' | 'forgot_password' | 'reset_otp' | 'new_password' | 'reset_success'>('login');

const otpDigits   = ref(['', '', '', '', '', '']);
const cooldown    = ref(0);
let timerInterval: any = null;

const newPassword        = ref("");
const confirmPassword    = ref("");
const showNewPassword    = ref(false);
const showConfirmPassword= ref(false);
const newPasswordTouched = ref(false);
const confirmPasswordTouched = ref(false);

const router    = useRouter();
const route     = useRoute();
const authStore = useAuthStore();

const touched = ref({ email: false, password: false });
const otpInputs = ref<HTMLInputElement[]>([]);

// ── Lifecycle ──────────────────────────────────────────────────────────────
onMounted(() => {
  if (route.query.expired === "true") {
    toast.error("Your session has expired. Please log in again.", {
      autoClose: 5000,
      position: toast.POSITION.TOP_CENTER,
    });
    router.replace({ path: "/login", query: { ...route.query, expired: undefined } });
  }
});

// ── Validation ────────────────────────────────────────────────────────────
const emailError = computed(() => {
  if (!touched.value.email) return "";
  if (!email.value.trim()) return "Email address is required";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) return "Please enter a valid email";
  return "";
});

const passwordError = computed(() => {
  if (!touched.value.password) return "";
  if (!password.value) return "Password is required";
  if (password.value.length < 6) return "Password must be at least 6 characters";
  return "";
});

const isFormValid = computed(() => {
  if (loginMethod.value === 'otp') return !emailError.value && email.value;
  return !emailError.value && !passwordError.value && email.value && password.value;
});

// ── Login ──────────────────────────────────────────────────────────────────
async function handleLogin() {
  errorMessage.value  = "";
  touched.value.email   = true;
  if (loginMethod.value === 'password') touched.value.password = true;

  if (!isFormValid.value) return;

  isLoading.value = true;
  
  if (loginMethod.value === 'password') {
    // Password Login: Use the real API
    try {
      const payload  = { email: email.value, password: password.value };
      const response = await apiService.post("cms/login", payload);

      // Handle Password Expired if returned in success body
      if (response?.password_expired) {
        toast.warning("Your password has expired. Please reset it to continue.");
        handleResetRequest(true); // Call real API to send OTP
        return;
      }

      const token =
        response?.token || response?.data?.token || response?.data?.access_token;

      if (token) {
        toast.success("Welcome back! Signing you in…");
        localStorage.setItem("token", token);
        authStore.setToken(token);

        const user = response?.data?.user || response?.user;
        if (user) {
          authStore.setUser({
            id:         user._id,
            name:       user.name,
            email:      user.email,
            roleTitle:  user.role_id?.title || "User",
            profilePic: user.profile_pic || "",
          });

          if (user.role_id) {
            const { usePermissionsStore } = await import("@/store/permissions");
            const permissionsStore = usePermissionsStore();
            permissionsStore.setPermissions(
              user.role_id.title || "",
              user.role_id.permissions || []
            );
          }
        }

        let redirect = (router.currentRoute.value.query.redirect as string) || "/";
        if (redirect.includes("/login") || redirect.includes("/auth/login")) redirect = "/";
        if (!redirect.startsWith("/")) redirect = "/" + redirect;

        await nextTick();
        try {
          await router.push(redirect);
          setTimeout(() => {
            if (router.currentRoute.value.path === "/login") {
              window.location.href = redirect;
            }
          }, 500);
        } catch {
          window.location.href = redirect;
        }
      } else {
        toast.error("Login failed — no token received");
      }
    } catch (error: any) {
      // Handle Password Expired if returned in error response
      if (error?.response?.data?.password_expired) {
        toast.warning("Your password has expired. Please reset it to continue.");
        handleResetRequest(true);
        return;
      }
      toast.error("Invalid credentials. Please try again.");
      errorMessage.value =
        error?.response?.data?.message || "Login failed. Please check your credentials.";
    } finally {
      isLoading.value = false;
    }
  } else {
    // OTP Login: Real API call
    try {
      await apiService.sendLoginOTP(email.value);
      loginStep.value = 'otp';
      startCooldown();
      toast.info("OTP sent to your email!");
      
      // Auto focus first OTP input
      nextTick(() => {
        otpInputs.value[0]?.focus();
      });
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to send OTP. Please check your email.");
      errorMessage.value = error?.response?.data?.message || "Failed to send OTP.";
    } finally {
      isLoading.value = false;
    }
  }
}

// ── OTP Logic ─────────────────────────────────────────────────────────────
function startCooldown() {
  cooldown.value = 30;
  if (timerInterval) clearInterval(timerInterval);
  timerInterval = setInterval(() => {
    if (cooldown.value > 0) cooldown.value--;
    else clearInterval(timerInterval);
  }, 1000);
}

function handleOtpInput(index: number, event: any) {
  const value = event.target.value;
  // Only allow numbers
  if (!/^\d*$/.test(value)) {
    otpDigits.value[index] = "";
    return;
  }

  if (value && index < 5) {
    otpInputs.value[index + 1]?.focus();
  }
}

function handleOtpKeyDown(index: number, event: KeyboardEvent) {
  if (event.key === "Backspace" && !otpDigits.value[index] && index > 0) {
    otpInputs.value[index - 1]?.focus();
  }
}

async function handleOtpSubmit() {
  const otp = otpDigits.value.join("");
  if (otp.length < 6) {
    toast.error("Please enter the full 6-digit code");
    return;
  }

  isLoading.value = true;
  try {
    const response = await apiService.verifyLoginOTP(email.value, otp);
    
    // Process successful OTP login
    const token = response?.token || response?.data?.token || response?.data?.access_token;
    if (token) {
      toast.success("OTP Verified! Signing you in...");
      localStorage.setItem("token", token);
      authStore.setToken(token);

      const user = response?.data?.user || response?.user;
      if (user) {
        authStore.setUser({
          id:         user._id,
          name:       user.name,
          email:      user.email,
          roleTitle:  user.role_id?.title || "User",
          profilePic: user.profile_pic || "",
        });

        if (user.role_id) {
          const { usePermissionsStore } = await import("@/store/permissions");
          const permissionsStore = usePermissionsStore();
          permissionsStore.setPermissions(
            user.role_id.title || "",
            user.role_id.permissions || []
          );
        }
      }

      let redirect = (router.currentRoute.value.query.redirect as string) || "/";
      if (redirect.includes("/login") || redirect.includes("/auth/login")) redirect = "/";
      if (!redirect.startsWith("/")) redirect = "/" + redirect;

      await nextTick();
      try {
        await router.push(redirect);
        setTimeout(() => {
          if (router.currentRoute.value.path === "/login") {
            window.location.href = redirect;
          }
        }, 500);
      } catch {
        window.location.href = redirect;
      }
    } else {
      toast.error("Verification successful but no token received");
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Invalid or expired OTP");
    errorMessage.value = error?.response?.data?.message || "Verification failed";
  } finally {
    isLoading.value = false;
  }
}

async function resendOtp() {
  if (cooldown.value > 0) return;
  isLoading.value = true;
  try {
    await apiService.sendLoginOTP(email.value);
    startCooldown();
    toast.info("A new OTP has been sent!");
  } catch (error: any) {
    toast.error("Failed to resend code");
  } finally {
    isLoading.value = false;
  }
}

function backToLogin() {
  loginStep.value = 'login';
  errorMessage.value = "";
}

// ── Reset Password Logic ──────────────────────────────────────────────────
function openForgotPassword() {
  loginStep.value = 'forgot_password';
  errorMessage.value = "";
}

async function handleResetRequest(autoTrigger = false) {
  if (!autoTrigger) {
    touched.value.email = true;
    if (emailError.value) return;
  }

  isLoading.value = true;
  try {
    await apiService.post("cms/request-password-otp", { email: email.value });
    isLoading.value = false;
    loginStep.value = 'reset_otp';
    startCooldown();
    toast.info("Verification code sent to your email!");
    nextTick(() => { otpInputs.value[0]?.focus(); });
  } catch (error: any) {
    isLoading.value = false;
    toast.error(error?.response?.data?.message || "Failed to send reset code");
  }
}

function handleResetOtpVerify() {
  const otp = otpDigits.value.join("");
  if (otp.length < 6) return toast.error("Please enter the 6-digit code");
  
  // Transition to new password screen (API call happens at the end)
  loginStep.value = 'new_password';
}

const newPasswordError = computed(() => {
  if (!newPasswordTouched.value) return "";
  if (!newPassword.value) return "New password is required";
  if (newPassword.value.length < 6) return "Password must be at least 6 characters";
  return "";
});

const confirmPasswordError = computed(() => {
  if (!confirmPasswordTouched.value) return "";
  if (confirmPassword.value !== newPassword.value) return "Passwords do not match";
  return "";
});

async function handleNewPasswordSubmit() {
  newPasswordTouched.value = true;
  confirmPasswordTouched.value = true;
  
  if (newPasswordError.value || confirmPasswordError.value || !newPassword.value) return;

  isLoading.value = true;
  try {
    const payload = {
      email: email.value,
      otp: otpDigits.value.join(""),
      new_password: newPassword.value
    };
    await apiService.post("cms/reset-password", payload);
    
    isLoading.value = false;
    loginStep.value = 'reset_success';
    toast.success("Password updated successfully!");
  } catch (error: any) {
    isLoading.value = false;
    toast.error(error?.response?.data?.message || "Failed to reset password");
  }
}

onUnmounted(() => {
  if (timerInterval) clearInterval(timerInterval);
});


// Clear top-level error on any input change
watch([email, password], () => {
  if (errorMessage.value) errorMessage.value = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[49] || (_cache[49] = _createElementVNode("div", {
      class: "orchit-orb orchit-orb--1",
      "aria-hidden": "true"
    }, null, -1)),
    _cache[50] || (_cache[50] = _createElementVNode("div", {
      class: "orchit-orb orchit-orb--2",
      "aria-hidden": "true"
    }, null, -1)),
    _cache[51] || (_cache[51] = _createElementVNode("div", {
      class: "orchit-orb orchit-orb--3",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"orchit-login-brand orchit-animate-fade-up orchit-animate-delay-1\" data-v-2904bb5c><img src=\"" + _imports_0 + "\" alt=\"Orchit CMS\" class=\"orchit-login-logo\" data-v-2904bb5c><div class=\"orchit-badge orchit-animate-fade-up orchit-animate-delay-2\" data-v-2904bb5c><svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" data-v-2904bb5c><circle cx=\"5\" cy=\"5\" r=\"5\" fill=\"currentColor\" data-v-2904bb5c></circle></svg> CMS </div></div>", 1)),
        (loginStep.value === 'login')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("h1", { class: "orchit-login-title" }, "Welcome back", -1),
              _createElementVNode("p", { class: "orchit-login-subtitle" }, "Sign in to your workspace to continue", -1)
            ]))]))
          : (loginStep.value === 'otp' || loginStep.value === 'reset_otp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "orchit-login-title" }, "Verify it's you", -1)),
                (loginStep.value === 'otp')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                      _cache[16] || (_cache[16] = _createTextVNode("We sent a 6-digit code to ", -1)),
                      _createElementVNode("strong", _hoisted_7, _toDisplayString(email.value), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "Enter the verification code sent to your email"))
              ]))
            : (loginStep.value === 'forgot_password')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("h1", { class: "orchit-login-title" }, "Reset password", -1),
                  _createElementVNode("p", { class: "orchit-login-subtitle" }, "Enter your email and we'll send you a link to reset your password.", -1)
                ]))]))
              : (loginStep.value === 'new_password')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("h1", { class: "orchit-login-title" }, "New password", -1),
                    _createElementVNode("p", { class: "orchit-login-subtitle" }, "Please create a unique password that you don't use anywhere else.", -1)
                  ]))]))
                : (loginStep.value === 'reset_success')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[20] || (_cache[20] = [
                      _createStaticVNode("<div class=\"orchit-success-icon-wrap\" data-v-2904bb5c><svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" data-v-2904bb5c><path d=\"M20 6L9 17L4 12\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2904bb5c></path></svg></div><h1 class=\"orchit-login-title\" data-v-2904bb5c>Password reset</h1><p class=\"orchit-login-subtitle\" data-v-2904bb5c>Your password has been successfully reset. Click below to log in magically.</p>", 3)
                    ]))]))
                  : _createCommentVNode("", true),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "8",
                  cy: "8",
                  r: "7",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }),
                _createElementVNode("path", {
                  d: "M8 5v3.5M8 11h.01",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
            ]))
          : _createCommentVNode("", true),
        (loginStep.value === 'login')
          ? (_openBlock(), _createElementBlock("form", {
              key: 6,
              onSubmit: _withModifiers(handleLogin, ["prevent"]),
              autocomplete: "off",
              novalidate: "",
              class: "orchit-login-form"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["orchit-field orchit-animate-fade-up orchit-animate-delay-2", { 'orchit-field--error': emailError.value }])
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("label", {
                  for: "login-email",
                  class: "orchit-label"
                }, "Email address", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", {
                    class: "orchit-input-icon",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none"
                    }, [
                      _createElementVNode("rect", {
                        x: "1",
                        y: "3",
                        width: "14",
                        height: "10",
                        rx: "2",
                        stroke: "currentColor",
                        "stroke-width": "1.4"
                      }),
                      _createElementVNode("path", {
                        d: "M1 5.5l6.293 4.293a1 1 0 001.414 0L15 5.5",
                        stroke: "currentColor",
                        "stroke-width": "1.4"
                      })
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    type: "email",
                    id: "login-email",
                    class: _normalizeClass(["orchit-input", { 'is-error': emailError.value }]),
                    placeholder: "you@company.com",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (touched.value.email = true)),
                    autocomplete: "off",
                    "aria-describedby": "email-error"
                  }, null, 34), [
                    [_vModelText, email.value]
                  ])
                ]),
                (emailError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _cache[23] || (_cache[23] = _createElementVNode("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("circle", {
                          cx: "6",
                          cy: "6",
                          r: "5",
                          stroke: "currentColor",
                          "stroke-width": "1.2"
                        }),
                        _createElementVNode("path", {
                          d: "M6 4v2.5M6 8.5h.01",
                          stroke: "currentColor",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(emailError.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (loginMethod.value === 'password')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["orchit-field orchit-animate-fade-up orchit-animate-delay-3", { 'orchit-field--error': passwordError.value }])
                  }, [
                    _createElementVNode("div", { class: "orchit-field-row" }, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "login-password",
                        class: "orchit-label"
                      }, "Password", -1)),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "orchit-forgot-link",
                        onClick: openForgotPassword,
                        tabindex: "-1"
                      }, "Forgot password?")
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", {
                        class: "orchit-input-icon",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none"
                        }, [
                          _createElementVNode("rect", {
                            x: "3",
                            y: "7",
                            width: "10",
                            height: "8",
                            rx: "1.5",
                            stroke: "currentColor",
                            "stroke-width": "1.4"
                          }),
                          _createElementVNode("path", {
                            d: "M5 7V5a3 3 0 016 0v2",
                            stroke: "currentColor",
                            "stroke-width": "1.4",
                            "stroke-linecap": "round"
                          })
                        ])
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                        type: showPassword.value ? 'text' : 'password',
                        id: "login-password",
                        class: _normalizeClass(["orchit-input orchit-input--password", { 'is-error': passwordError.value }]),
                        placeholder: "Enter your password",
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (touched.value.password = true)),
                        autocomplete: "off",
                        "aria-describedby": "password-error"
                      }, null, 42, _hoisted_16), [
                        [_vModelDynamic, password.value]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "orchit-toggle-pw",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
                        "aria-label": showPassword.value ? 'Hide password' : 'Show password',
                        tabindex: "-1"
                      }, [
                        (!showPassword.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("path", {
                                d: "M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z",
                                stroke: "currentColor",
                                "stroke-width": "1.4"
                              }, null, -1),
                              _createElementVNode("circle", {
                                cx: "8",
                                cy: "8",
                                r: "2",
                                stroke: "currentColor",
                                "stroke-width": "1.4"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("path", {
                                d: "M13.5 3L2.5 13M6.3 6.4A2 2 0 009.6 9.7M3.7 4.9C2.3 6 1 8 1 8s2.5 5 7 5c1.3 0 2.5-.4 3.6-1M6.2 2.6C6.8 2.2 7.4 3 8 3c4.5 0 7 5 7 5s-.7 1.4-1.9 2.7",
                                stroke: "currentColor",
                                "stroke-width": "1.4",
                                "stroke-linecap": "round"
                              }, null, -1)
                            ]))]))
                      ], 8, _hoisted_17)
                    ]),
                    (passwordError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                          _cache[29] || (_cache[29] = _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("circle", {
                              cx: "6",
                              cy: "6",
                              r: "5",
                              stroke: "currentColor",
                              "stroke-width": "1.2"
                            }),
                            _createElementVNode("path", {
                              d: "M6 4v2.5M6 8.5h.01",
                              stroke: "currentColor",
                              "stroke-width": "1.2",
                              "stroke-linecap": "round"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(passwordError.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                id: "login-submit-btn",
                type: "submit",
                class: "orchit-btn-primary orchit-login-submit orchit-animate-fade-up orchit-animate-delay-4",
                disabled: isLoading.value
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                  : _createCommentVNode("", true),
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[30] || (_cache[30] = [
                        _createElementVNode("path", {
                          d: "M3 8h10M9 4l4 4-4 4",
                          stroke: "currentColor",
                          "stroke-width": "1.6",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ]))]))
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(isLoading.value ? (loginMethod.value === 'password' ? 'Signing in...' : 'Sending OTP...') : (loginMethod.value === 'password' ? 'Sign in' : 'Send OTP')), 1)
              ], 8, _hoisted_21),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "orchit-toggle-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (loginMethod.value = loginMethod.value === 'password' ? 'otp' : 'password'))
                }, _toDisplayString(loginMethod.value === 'password' ? 'Sign in with OTP instead' : 'Sign in with Password instead'), 1)
              ])
            ], 32))
          : (loginStep.value === 'otp' || loginStep.value === 'reset_otp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otpDigits.value, (digit, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: index,
                      ref_for: true,
                      ref_key: "otpInputs",
                      ref: otpInputs,
                      "onUpdate:modelValue": ($event: any) => ((otpDigits.value[index]) = $event),
                      type: "text",
                      maxlength: "1",
                      class: "orchit-otp-input",
                      onInput: ($event: any) => (handleOtpInput(index, $event)),
                      onKeydown: ($event: any) => (handleOtpKeyDown(index, $event)),
                      autocomplete: "one-time-code",
                      disabled: isLoading.value
                    }, null, 40, _hoisted_28)), [
                      [_vModelText, otpDigits.value[index]]
                    ])
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (cooldown.value > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                        _cache[31] || (_cache[31] = _createTextVNode(" Resend code in ", -1)),
                        _createElementVNode("span", null, _toDisplayString(cooldown.value) + "s", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "orchit-resend-btn",
                        onClick: resendOtp
                      }, [...(_cache[32] || (_cache[32] = [
                        _createTextVNode(" Didn't receive code? ", -1),
                        _createElementVNode("span", null, "Resend", -1)
                      ]))]))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (loginStep.value === 'otp' ? handleOtpSubmit() : handleResetOtpVerify())),
                  class: "orchit-btn-primary orchit-login-submit",
                  disabled: isLoading.value || otpDigits.value.join('').length < 6
                }, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Verifying...' : 'Verify and continue'), 1)
                ], 8, _hoisted_31),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "orchit-back-link",
                    onClick: backToLogin,
                    disabled: isLoading.value
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", {
                        d: "M19 12H5M12 19l-7-7 7-7",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1),
                    _createTextVNode(" Return to Sign In ", -1)
                  ]))], 8, _hoisted_34)
                ])
              ]))
            : (loginStep.value === 'forgot_password')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 8,
                  onSubmit: _withModifiers(handleResetRequest, ["prevent"]),
                  class: "orchit-login-form orchit-animate-fade-up"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["orchit-field", { 'orchit-field--error': emailError.value }])
                  }, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", {
                      for: "reset-email",
                      class: "orchit-label"
                    }, "Email address", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "orchit-input-icon" }, [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none"
                        }, [
                          _createElementVNode("rect", {
                            x: "1",
                            y: "3",
                            width: "14",
                            height: "10",
                            rx: "2",
                            stroke: "currentColor",
                            "stroke-width": "1.4"
                          }),
                          _createElementVNode("path", {
                            d: "M1 5.5l6.293 4.293a1 1 0 001.414 0L15 5.5",
                            stroke: "currentColor",
                            "stroke-width": "1.4"
                          })
                        ])
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((email).value = $event)),
                        type: "email",
                        id: "reset-email",
                        class: "orchit-input",
                        placeholder: "you@company.com",
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (touched.value.email = true))
                      }, null, 544), [
                        [_vModelText, email.value]
                      ])
                    ]),
                    (emailError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(emailError.value), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "orchit-btn-primary orchit-login-submit",
                    disabled: isLoading.value
                  }, [
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Sending...' : 'Send reset instructions'), 1)
                  ], 8, _hoisted_37),
                  _createElementVNode("div", { class: "orchit-back-to-login-wrap" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "orchit-back-link",
                      onClick: backToLogin
                    }, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", {
                          d: "M19 12H5M12 19l-7-7 7-7",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1),
                      _createTextVNode(" Return to Sign In ", -1)
                    ]))])
                  ])
                ], 32))
              : (loginStep.value === 'new_password')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 9,
                    onSubmit: _withModifiers(handleNewPasswordSubmit, ["prevent"]),
                    class: "orchit-login-form orchit-animate-fade-up"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["orchit-field", { 'orchit-field--error': newPasswordError.value }])
                    }, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "orchit-label" }, "New password", -1)),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "orchit-input-icon" }, [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "7",
                              width: "10",
                              height: "8",
                              rx: "1.5",
                              stroke: "currentColor",
                              "stroke-width": "1.4"
                            }),
                            _createElementVNode("path", {
                              d: "M5 7V5a3 3 0 016 0v2",
                              stroke: "currentColor",
                              "stroke-width": "1.4",
                              "stroke-linecap": "round"
                            })
                          ])
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newPassword).value = $event)),
                          type: showNewPassword.value ? 'text' : 'password',
                          class: "orchit-input",
                          placeholder: "Min 6 characters",
                          onBlur: _cache[10] || (_cache[10] = ($event: any) => (newPasswordTouched.value = true))
                        }, null, 40, _hoisted_40), [
                          [_vModelDynamic, newPassword.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "orchit-toggle-pw",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
                        }, [
                          (!showNewPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_41, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("path", {
                                  d: "M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4"
                                }, null, -1),
                                _createElementVNode("circle", {
                                  cx: "8",
                                  cy: "8",
                                  r: "2",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4"
                                }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_42, [...(_cache[38] || (_cache[38] = [
                                _createElementVNode("path", {
                                  d: "M13.5 3L2.5 13M6.3 6.4A2 2 0 009.6 9.7M3.7 4.9C2.3 6 1 8 1 8s2.5 5 7 5c1.3 0 2.5-.4 3.6-1M6.2 2.6C6.8 2.2 7.4 3 8 3c4.5 0 7 5 7 5s-.7 1.4-1.9 2.7",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linecap": "round"
                                }, null, -1)
                              ]))]))
                        ])
                      ]),
                      (newPasswordError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(newPasswordError.value), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["orchit-field", { 'orchit-field--error': confirmPasswordError.value }])
                    }, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "orchit-label" }, "Confirm password", -1)),
                      _createElementVNode("div", _hoisted_44, [
                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "orchit-input-icon" }, [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "7",
                              width: "10",
                              height: "8",
                              rx: "1.5",
                              stroke: "currentColor",
                              "stroke-width": "1.4"
                            }),
                            _createElementVNode("path", {
                              d: "M5 7V5a3 3 0 016 0v2",
                              stroke: "currentColor",
                              "stroke-width": "1.4",
                              "stroke-linecap": "round"
                            })
                          ])
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((confirmPassword).value = $event)),
                          type: showConfirmPassword.value ? 'text' : 'password',
                          class: "orchit-input",
                          placeholder: "Repeat password",
                          onBlur: _cache[13] || (_cache[13] = ($event: any) => (confirmPasswordTouched.value = true))
                        }, null, 40, _hoisted_45), [
                          [_vModelDynamic, confirmPassword.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "orchit-toggle-pw",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value))
                        }, [
                          (!showConfirmPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_46, [...(_cache[41] || (_cache[41] = [
                                _createElementVNode("path", {
                                  d: "M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4"
                                }, null, -1),
                                _createElementVNode("circle", {
                                  cx: "8",
                                  cy: "8",
                                  r: "2",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4"
                                }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_47, [...(_cache[42] || (_cache[42] = [
                                _createElementVNode("path", {
                                  d: "M13.5 3L2.5 13M6.3 6.4A2 2 0 009.6 9.7M3.7 4.9C2.3 6 1 8 1 8s2.5 5 7 5c1.3 0 2.5-.4 3.6-1M6.2 2.6C6.8 2.2 7.4 3 8 3c4.5 0 7 5 7 5s-.7 1.4-1.9 2.7",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linecap": "round"
                                }, null, -1)
                              ]))]))
                        ])
                      ]),
                      (confirmPasswordError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(confirmPasswordError.value), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "orchit-btn-primary orchit-login-submit",
                      disabled: isLoading.value
                    }, [
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Updating...' : 'Update password'), 1)
                    ], 8, _hoisted_49),
                    _createElementVNode("div", { class: "orchit-back-to-login-wrap" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "orchit-back-link",
                        onClick: backToLogin
                      }, [...(_cache[45] || (_cache[45] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", {
                            d: "M19 12H5M12 19l-7-7 7-7",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1),
                        _createTextVNode(" Return to Sign In ", -1)
                      ]))])
                    ])
                  ], 32))
                : (loginStep.value === 'reset_success')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("button", {
                        onClick: backToLogin,
                        class: "orchit-btn-primary orchit-login-submit"
                      }, " All set! Back to login ")
                    ]))
                  : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_52, [
          _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " ", 1),
          _cache[46] || (_cache[46] = _createElementVNode("span", {
            class: "orchit-gradient-text",
            style: {"font-weight":"700"}
          }, "Orchit CMS", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _cache[48] || (_cache[48] = _createStaticVNode("<div class=\"orchit-panel-orb orchit-panel-orb--1\" data-v-2904bb5c></div><div class=\"orchit-panel-orb orchit-panel-orb--2\" data-v-2904bb5c></div><div class=\"orchit-panel-content\" data-v-2904bb5c><div class=\"orchit-panel-icon-wrap\" data-v-2904bb5c><svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" class=\"orchit-panel-icon\" data-v-2904bb5c><rect width=\"48\" height=\"48\" rx=\"14\" fill=\"rgba(255,255,255,0.15)\" data-v-2904bb5c></rect><path d=\"M24 12L36 32H12L24 12Z\" fill=\"white\" opacity=\"0.9\" data-v-2904bb5c></path><circle cx=\"24\" cy=\"34\" r=\"3\" fill=\"white\" opacity=\"0.7\" data-v-2904bb5c></circle></svg></div><h2 class=\"orchit-panel-title\" data-v-2904bb5c> Orchestrate Your<br data-v-2904bb5c>Projects with AI </h2><p class=\"orchit-panel-text\" data-v-2904bb5c> From planning to delivery — manage your entire workflow with intelligent tools built for modern teams. </p><div class=\"orchit-panel-chips\" data-v-2904bb5c><span class=\"orchit-panel-chip\" data-v-2904bb5c><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" data-v-2904bb5c><path d=\"M2 6l3 3 5-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2904bb5c></path></svg> Real-time collaboration </span><span class=\"orchit-panel-chip\" data-v-2904bb5c><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" data-v-2904bb5c><path d=\"M2 6l3 3 5-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2904bb5c></path></svg> AI-powered insights </span><span class=\"orchit-panel-chip\" data-v-2904bb5c><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" data-v-2904bb5c><path d=\"M2 6l3 3 5-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2904bb5c></path></svg> Role-based access </span><span class=\"orchit-panel-chip\" data-v-2904bb5c><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" data-v-2904bb5c><path d=\"M2 6l3 3 5-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2904bb5c></path></svg> 360° reporting </span></div></div>", 3)),
          _createElementVNode("p", _hoisted_55, "© " + _toDisplayString(new Date().getFullYear()) + " Orchit CMS. All rights reserved.", 1)
        ])
      ])
    ])
  ]))
}
}

})